import * as CryptoJS from "crypto-js";

export default new class tmCryptoUtils {
  // Se deriva la clave a partir del token, usando SHA‑256 para obtener 32 bytes.
  private key: CryptoJS.lib.WordArray;

  constructor() {
    const secret =
      "9S2dmB4LShLQVM3svUWLLExgI6jikexd9ABASeRMe5mqMG28QFPBIYhO3ftXkJCMBWz63KQDTEaJEPGSJGJjylax53gA7aooWbJpmMzyrq";
    this.key = CryptoJS.SHA256(secret);
  }

  /**
   * Genera un vector de inicialización (IV) aleatorio de 16 bytes.
   */
  private generateIV(): CryptoJS.lib.WordArray {
    return CryptoJS.lib.WordArray.random(16); // 16 bytes (128 bits) para AES-CBC
  }

  /**
   * Codifica una cadena UTF-8 a Base64.
   */
  private encodeBase64(input: string): string {
    if (typeof btoa === "function") {
      return btoa(input);
    } else {
      return Buffer.from(input).toString("base64");
    }
  }

  /**
   * Decodifica una cadena Base64 a UTF-8.
   */
  private decodeBase64(input: string): string {
    if (typeof atob === "function") {
      return atob(input);
    } else {
      return Buffer.from(input, "base64").toString("utf8");
    }
  }

  /**
   * Encripta los datos recibidos.
   * - Convierte los datos (data) en JSON.
   * - Genera un IV aleatorio.
   * - Encripta usando AES-CBC y empaqueta en un payload con el ciphertext y el IV, ambos en Base64.
   * - Serializa el payload y lo codifica a Base64.
   * @param data Datos a encriptar.
   */
  async encrypt(data: unknown): Promise<string> {
    const iv = this.generateIV();
    const dataString = JSON.stringify(data);

    // Encriptar usando CryptoJS, generando un objeto CipherParams.
    const encrypted = CryptoJS.AES.encrypt(dataString, this.key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Se obtiene el ciphertext en Base64 y el IV también en Base64.
    const payload = {
      data: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
      iv: iv.toString(CryptoJS.enc.Base64),
    };

    const payloadString = JSON.stringify(payload);
    return this.encodeBase64(payloadString);
  }

  /**
   * Desencripta el payload recibido.
   * - Se decodifica el payload desde Base64 y se parsea a JSON.
   * - Se reconstruyen el IV y el ciphertext a partir de sus representaciones Base64.
   * - Se desencripta utilizando AES-CBC y se parsea el resultado a JSON.
   * @param data Payload cifrado en Base64.
   */
  async decrypt(data: string): Promise<any> {
    const payloadString = this.decodeBase64(data);
    const payload = JSON.parse(payloadString);

    if (payload && typeof payload.iv === "string" && typeof payload.data === "string") {
      // Reconstruir IV y ciphertext a partir de sus representaciones Base64.
      const iv = CryptoJS.enc.Base64.parse(payload.iv);
      const ciphertext = CryptoJS.enc.Base64.parse(payload.data);
      const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: ciphertext,
      });
      const decrypted = CryptoJS.AES.decrypt(cipherParams, this.key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedText);
    } else {
      throw new Error("Formato de payload inválido");
    }
  }
}();